/* eslint-disable react/prop-types */
import React from 'react';
import { styled } from '@mui/system';
import { ButtonBase, Card, CardContent, Box } from '@mui/material';

const AnimatedCard = styled(Card)({
  width: '100%',
  height: '100%',
  transition: 'background-color 0.3s ease',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
    transform: 'scale(1.05)',
  },
});

const CardButton = styled(ButtonBase)({
  width: '100%',
  height: '100%',
});

const CenteredIcon = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
});

const MenuButton = ({ title, icon, onClick, backgroundColor = 'primary' }) => {
  return (
    <AnimatedCard sx={{ backgroundColor: backgroundColor }}>
      <CardButton onClick={onClick ? onClick : () => { }}>
        <CardContent sx={{ textAlign: 'center' }}>
          <CenteredIcon>{icon}</CenteredIcon>
          <h2>{title}</h2>
        </CardContent>
      </CardButton>
    </AnimatedCard>
  );
};

export default MenuButton;
